"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capture = void 0;

var _html2canvas = _interopRequireDefault(require("html2canvas"));

var _IGC_JS2Native = require("../IGC_JS2Native");

var _common = require("../common");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * @file 客户端截屏并分享函数
 * @author qiaogang
 * @date 2020-02-13
 */

/**
 * 利用 App 进行截屏、截指定 DOM 区域，并进行分享或保存。
 */
var capture = {
  _options: {},
  config: function config(options) {
    return this;
  },

  /**
   * 截图
   * @param {Object} options
   * @options {HTMLElement=} options.el 截取的 DOM 元素
   * @options {string=} options.imageType 保存的图片类型，默认 image/png，如果需要减小图尺寸，建议使用 image/jpeg
   * @options {number=} options.encoderOptions 图片质量，0-1 区间，只至针对 jpeg 和 webp 有效。默认 0.92
   * @options {Object=} options.canvasOptions html2canvas 的 config 配置项
   * @options {Object=} options.shareOptions JS2Native 的 params 属性，可以指定分享渠道
   * @options {Function=} options.beforeShare 触发分享前的钩子函数，返回 true 时停止调用 App 的分享
   * @return {Promise}
   */
  snapshot: function snapshot(options) {
    var _this = this;

    return new Promise(function (resolve, reject) {
      var el = options.el,
          _options$captureTimeo = options.captureTimeout,
          captureTimeout = _options$captureTimeo === void 0 ? 100 : _options$captureTimeo,
          _options$imageType = options.imageType,
          imageType = _options$imageType === void 0 ? 'image/png' : _options$imageType,
          encoderOptions = options.encoderOptions,
          canvasOptions = options.canvasOptions,
          shareOptions = options.shareOptions,
          _options$beforeShare = options.beforeShare,
          beforeShare = _options$beforeShare === void 0 ? function () {} : _options$beforeShare;

      if (el) {
        var cavOpts = (0, _common.defaults)(canvasOptions, {
          width: el.offsetWidth,
          height: el.offsetHeight,
          useCORS: true
        });
        (0, _html2canvas["default"])(el, cavOpts).then(function (canvas) {
          var context = canvas.getContext('2d');
          context.mozImageSmoothingEnabled = false;
          context.webkitImageSmoothingEnabled = false;
          context.msImageSmoothingEnabled = false;
          context.imageSmoothingEnabled = false;
          var skip = beforeShare.call(_this, {
            el: el,
            canvas: canvas
          });

          if (skip) {
            reject();
          } else {
            var base64Img = canvas.toDataURL(imageType, encoderOptions);
            var params = (0, _common.defaults)(shareOptions, {
              channel: ['WXFRIEND', 'WXPYQ', 'SAVE'],
              // 0：链接，(原来的'web')、1：图片、2：音乐
              shareType: 1,
              shareInfo: {
                shareCover: base64Img
              },
              event: 'sndd_app_traffic'
            });
            setTimeout(function () {
              (0, _IGC_JS2Native.JS2Native)({
                name: 'webShare',
                params: params
              });
              resolve();
            }, captureTimeout);
          }
        });
      } else {// TODO 全屏截图
      }
    });
  },
  replaceHost: function replaceHost(imgUrl) {
    // 由于 cdn 的域名和 H5 的 igetcool-share 域名存在跨域，会导图片跨域，截图在部分 ios 下失败。
    // 其中域名转发是在 h5 nginx 中配置的
    // 1. 回源地址转换 http://igetcool.oss-cn-beijing.aliyuncs.com/p/client/config/ic_def_boy_avatar.png => ${location.origin}/coolcdn/p/client/config/ic_def_boy_avatar.png
    // 2. cdn地址转换 https://coolcdn.igetcool.com/p/2020/2/d08df052cf41815a699938935616ac59.jpg => ${location.origin}/coolcdn/p/2020/2/d08df052cf41815a699938935616ac59.jpg
    var imgUrl2 = imgUrl;
    var preRE = /^((http|https):)?\/\/((coolcdn\.igetcool\.com)|(igetcool\.oss-cn-beijing\.aliyuncs\.com))/i;
    imgUrl2 = imgUrl2.replace(preRE, "".concat(location.origin, "/coolcdn"));
    return imgUrl2;
  },
  replaceWxHost: function replaceWxHost(imgUrl) {
    // 替换微信host
    var imgUrl2 = imgUrl;
    var preRE = /^((http|https):)?\/\/thirdwx\.qlogo\.cn/i;
    imgUrl2 = imgUrl2.replace(preRE, "".concat(location.origin, "/wximg"));
    return imgUrl2;
  }
};
exports.capture = capture;